"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.ACTION = void 0;
exports.ACTION = {
    SUCCESS: 'success',
    FAIL: 'failed',
};
//# sourceMappingURL=const.js.map